"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleTransporter = void 0;
var transporter_1 = require("./transporter");
var ConsoleTransporter = /** @class */ (function (_super) {
    __extends(ConsoleTransporter, _super);
    function ConsoleTransporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConsoleTransporter.prototype.log = function (logData) {
        var data = logData;
        switch (data["Level"]) {
            case "DEBUG":
                console.debug(logData);
                break;
            case "INFO":
                console.info(logData);
                break;
            case "WARN":
                console.warn(logData);
                break;
            default: // ERROR
                console.error(logData);
        }
    };
    ConsoleTransporter.prototype.dispose = function () {
        // deliberately left empty
    };
    return ConsoleTransporter;
}(transporter_1.Transporter));
exports.ConsoleTransporter = ConsoleTransporter;
//# sourceMappingURL=consoleTransporter.js.map